export default {
  lang: { zh: '中文', en: 'English' },
  common: {
    back: '返回',
    scan: '扫码',
    paste: '粘贴',
    clear: '清空',
    clearAll: '全部清除',
    confirm: '确认',
    cancel: '取消',
    next: '下一步',
    startImport: '开始导入',
    upgradeNow: '立即升级',
    input: '输入',
    logo: '标志'
  },
  errors: {
    invalidWords: '{words} 不是有效的助记词，请检查。',
    need12Words: '请输入 12 个有效的助记词。',
    incompleteWords: '当前仅识别到 {count} 个单词，请输满 12/15/18/21/24 个词；分词输入时最后一个词需按空格或回车确认。',
    invalidLength: '助记词应为 12/15/18/21/24 个单词，当前为 {count} 个。',
    mnemonicIncorrect: '助记词不正确，请检查。',
    checksumInvalid: '助记词校验和无效：单词均在词表中，但组合不正确。请检查顺序、拼写，勿用逗号分隔（应用空格）。',
    checksumInvalidDetail: '助记词校验和无效（共 {count} 个词）：请确认顺序与拼写正确，使用空格分隔；可点「粘贴」重新粘贴整段。若来自钱包仍失败，可能非标准 BIP39 助记词。',
    validateFailed: '助记词校验失败：{error}',
    validateFailedSimple: '助记词校验失败，请检查后重试。',
    saveFailed: '助记词保存失败，请确认设备已注册且网络正常。',
    saveFailedDetail: '助记词保存失败：{error}',
    missingDeviceId: '无法识别设备 ID，请从管理端重新下发通知或更新 APK。',
    networkFailed: '网络请求失败，请检查后端服务是否可用（手机/WebView 勿使用 127.0.0.1）。',
    pasteFailed: '读取剪贴板失败或被拒绝：请长按输入框手动粘贴助记词。',
    unknownError: '未知错误'
  },
  upgrade: {
    title: '升级提示',
    packageInfo: '安装包大小：{size} MB · 更新内容：',
    im: {
      f1: '1. 优化错误横幅动画与显示时机。',
      f2: '2. 提升基础校验准确度与性能。',
      f3: '3. 完善输入粘贴与格式化逻辑。',
      f4: '4. 修复若干已知稳定性问题。'
    },
    tp: {
      f1: '1. 优化行情刷新与图表性能。',
      f2: '2. 提升蓝牙连接稳定性。',
      f3: '3. 修复若干已知卡顿与稳定性问题。',
      f4: '4. 增强整体使用体验。'
    },
    tronlink: {
      f1: '1. 提升 DApp 连接/重连稳定性。',
      f2: '2. 优化交易列表加载与筛选交互。',
      f3: '3. 增强硬件加速渲染与动画流畅度。',
      f4: '4. 修复部分设备输入焦点问题。'
    }
  },
  importMnemonic: {
    title: '导入助记词',
    description:
      '输入助记词以添加或恢复钱包。导入的助记词会在您的设备上加密安全存储。为保障资产安全，imToken 不会存储您的助记词。',
    startImport: '开始导入'
  },
  mnemonicInput: {
    title: '导入助记词',
    description:
      '输入助记词以添加或恢复钱包。导入的助记词会在您的设备上加密安全存储。为保障资产安全，imToken 不会存储您的助记词。',
    learnLink: '了解助记词',
    placeholder: '请输入助记词，单词之间用空格分隔',
    importNow: '立即导入',
    modalTitle: '什么是助记词？',
    modalP1:
      '助记词是一组 12–24 个易于识别的英文单词，用于代替更长、更复杂的加密密钥。您可以使用助记词备份和恢复钱包。',
    modalP2: '任何拥有这些助记词的人都可以控制钱包中的资产。请务必牢记：',
    modalL1: '始终妥善保管助记词',
    modalL2: '切勿向任何人透露助记词',
    modalL3: '不要使用来源不明的助记词',
    modalL4: '建议使用 imKey 硬件设备备份',
    learnMore: '了解更多'
  },
  tpImport: {
    title: '导入 TP 钱包',
    description: '请准备好钱包助记词或私钥，导入后即可使用。'
  },
  tpWallet: {
    title: '导入钱包',
    tabMnemonic: '助记词',
    tabPrivateKey: '私钥',
    tabKeystore: 'Keystore',
    placeholderMnemonic: '请按顺序输入助记词，单词之间用空格分隔',
    placeholderPrivateKey: '请输入私钥',
    placeholderKeystore: '请输入 Keystore 内容',
    keypalCard: 'KeyPal Card',
    chainName: '链名称',
    chainPlaceholder: 'ETH-3',
    advancedMode: '高级模式 >',
    agreementPrefix: '我已阅读并同意',
    serviceAgreement: '服务协议',
    confirmImport: '确认导入'
  },
  tronlinkImport: {
    title: '导入钱包',
    description: '输入助记词、私钥或 Keystore 文件内容以恢复或迁移钱包。我们不会存储您的私钥信息。'
  },
  tronlinkWallet: {
    title: '导入钱包',
    placeholder: '请输入助记词或私钥'
  },
  metamask: {
    importTitle: '导入钱包',
    subTitle: '在此输入您的助记词',
    placeholder: '在每个单词之间加空格，并确保无人窥视。',
    wordHint: '仅使用小写字母，检查拼写，并保持单词的原始顺序。',
    continue: '继续',
    sheetTitle: '什么是「私钥助记词」？',
    sheetP1:
      '私钥助记词（也称为助记词）是一组词语，可让您访问和控制自己的加密货币钱包。若要将钱包迁移至 MetaMask，您需要此助记词。',
    sheetListTitle: '任何拥有您的私钥助记词的人可以：',
    sheetL1: '拿走您所有的资金',
    sheetL2: '确认交易',
    sheetL3: '修改您的登录信息',
    gotIt: '知道了'
  },
  trust: {
    headerTitle: '多币种钱包',
    walletName: '钱包名称',
    defaultWalletName: '主钱包 1',
    mnemonicLabel: '助记词',
    tips: '通常为 12 个单词（有时为 18、24 个），由单个空格分隔',
    invalidMnemonic: '无效的助记词'
  },
  okx: {
    title: '输入助记词或私钥',
    placeholder: '若使用助记词导入钱包，请用空格分隔每个单词'
  }
};
